import React from 'react'
import ReactModal from 'react-modal'
import './Modal.css'

export default class Modal extends React.Component {
    render() {
        return (
            <ReactModal
                ariaHideApp={false}
                isOpen={this.props.isOpen}
                // className="modal__content modal__medium"
                className={`
                    modal__content 
                    ${this.props.size || `modal__medium`}
                    ${this.props.overflowY ? `modal__overflowY` : `modal__no_overflowY`}
                    `}
                overlayClassName="modal__overlay"
            >
                <div className="modal__title" style={{ marginTop: !this.props.title ? 10 : 0 }}>
                    {this.props.title ? (<h2>{this.props.title}</h2>) : ''}
                </div>
                {this.props.content}
            </ReactModal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.jsx